import { FunctionComponent, useState, useEffect } from "react";
import { FormControl, MenuItem, Select } from "@mui/material";
import TimeField from "../Shared/TimeField";
import {
  EstimatedProductionTimesType,
  MachineTypeEnum,
} from "types/products/ProductCommandsType";

// TODO: Move shared css to shared folder
import styles from "../Calculator/css/calculateRow.module.css";

type PropsType = {
  times?: EstimatedProductionTimesType | null;
  totalMultiplier?: number;
  onTimesChange?: (times: EstimatedProductionTimesType) => void;
};

const EstimatedProductionTimesFormSections: FunctionComponent<PropsType> = ({
  times,
  totalMultiplier,
  onTimesChange,
}) => {
  const {
    salesMachineType,
    salesCam,
    salesPreparation,
    salesMachining,
    salesPostProcessing,
  } = times ?? {};

  const [machineType, setMachineType] = useState(
    salesMachineType ?? MachineTypeEnum.AXIS_3,
  );
  const [camTime, setCamTime] = useState(salesCam ?? 0);
  const [preparationTime, setPreparationTime] = useState(salesPreparation ?? 0);
  const [machiningTime, setMachiningTime] = useState(salesMachining ?? 0);
  const [postProcessingTime, setPostProcessingTime] = useState(
    salesPostProcessing ?? 0,
  );

  useEffect(() => {
    if (onTimesChange) {
      onTimesChange({
        salesMachineType: machineType,
        salesCam: camTime,
        salesPreparation: preparationTime,
        salesMachining: machiningTime,
        salesPostProcessing: postProcessingTime,
      });
    }
  }, [
    camTime,
    preparationTime,
    machiningTime,
    postProcessingTime,
    machineType,
    onTimesChange,
  ]);

  const multiplier = totalMultiplier ?? 1;

  const totalCamTime = camTime * multiplier;
  const totalProductionTime = (preparationTime + machiningTime) * multiplier;
  const totalPostProcessingTime = postProcessingTime * multiplier;
  const totalTime =
    totalCamTime + totalProductionTime + totalPostProcessingTime;

  return (
    <div>
      <h5 className={`${styles.title}`}>{"Estimated Time"}</h5>
      <div className={`${styles.container}`}>
        <div className={`${styles.container__content}`}>
          <div
            className={`${styles.container__title}`}
            style={{ minWidth: "250px" }}
          >
            <span>{"Machine Type"}</span>
          </div>
          <div className={`${styles.content}`}>
            <FormControl size="small">
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={machineType}
                onChange={(e) =>
                  setMachineType(e.target.value as MachineTypeEnum)
                }
              >
                <MenuItem value={MachineTypeEnum.AXIS_3}>3Axis</MenuItem>
                <MenuItem value={MachineTypeEnum.AXIS_5}>5Axis</MenuItem>
                <MenuItem value={MachineTypeEnum.TURNING}>Turning</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
      <TimeField label="CAM" totalMinutes={camTime} onChange={setCamTime} />
      <TimeField
        label="Preparation (Material, Tool, etc.)"
        totalMinutes={preparationTime}
        onChange={setPreparationTime}
        tooltip="Material, Tool, etc"
      />
      <TimeField
        label="Machining (Setup, Milling, Turning, Deburring, QC)"
        totalMinutes={machiningTime}
        onChange={setMachiningTime}
        tooltip="Setup, Milling, Turning, QC"
      />
      <TimeField
        label="Surface Treatment (Polishing, Sanding, etc, QC)"
        totalMinutes={postProcessingTime}
        onChange={setPostProcessingTime}
        tooltip="Deburring, Sanding, etc, QA"
      />

      <h5 className={`${styles.title}`}>{"Total"}</h5>
      <TimeField
        label="CAM"
        totalMinutes={totalCamTime}
        onChange={() => {}}
        disabled
      />
      <TimeField
        label="Production time"
        totalMinutes={totalProductionTime}
        onChange={() => {}}
        disabled
      />
      <TimeField
        label="Post-Processing"
        totalMinutes={totalPostProcessingTime}
        onChange={() => {}}
        disabled
      />
      <TimeField
        label="Total Time"
        totalMinutes={totalTime}
        onChange={() => {}}
        disabled
      />
    </div>
  );
};

export default EstimatedProductionTimesFormSections;
